export default __webpack_public_path__ + "static/media/browser.5660934f.svg";